import { Cloudinary } from "cloudinary-core";

import { getPublicIdFromUrl } from "@merchstores/shared/components/Cloudinary";
import { shopifyImageResize } from "@merchstores/shared/components/Shopify";
import { ILogoMockupImageProps } from ".";

export const LogoMockupImage = (props: ILogoMockupImageProps) => {
  const { imgHeight, imgWidth, tags, logoUrl, imgUrl, cloudinarySource, classes } = props;
  const cloudinaryCore = new Cloudinary({
    cloud_name: "merchology",
    upload_preset: cloudinarySource ? cloudinarySource : "merchstores",
  });
  let validImage = false;
  if  (imgHeight && imgWidth && tags && logoUrl && imgUrl) {
    validImage = true;
  }
  let areaData = "";
  let mockupDimensions = {
    logoWidth: 0,
    logoX: 0,
    logoY: 0
  };
  tags.every((tag: string) => {
    const tagSplits = tag.split("=");
    if (tagSplits[0] === "LogoArea") {
      areaData = tagSplits[1];
      return false;
    } else {
      return true;
    }
  });
  if (areaData) {
    const areaDataSplits = areaData.split("-");
    if (areaDataSplits.length !== 3) {
      console.error(
        `Unable to generate logo mockup, LogoArea tag not properly formatted. Should be <img_x_percentage>-<img_y_percentage>-<logo_area_width>, is currently ${areaData}`
      );
      validImage = false;
    } else {
      const logoW = Math.round(imgWidth * (parseInt(areaDataSplits[2]) / 100));
      const logoH = logoW;
      let x = Math.round(imgWidth * (parseInt(areaDataSplits[0]) / 100));
      let y = Math.round(imgHeight * (parseInt(areaDataSplits[1]) / 100));

      let imgW = undefined;
      let imgH = undefined;

      if (imgWidth < imgHeight) {
        imgW = logoW;
        imgH = imgHeight * (logoW / imgWidth);
      } else {
        imgH = logoH;
        imgW = imgWidth * (logoH / imgHeight);
      }
      if (imgW < logoW) {
        x += Math.round((logoW - imgW) / 2);
      }
      if (imgH < logoW) {
        y += Math.round((logoW - imgH) / 2);
      }
      mockupDimensions = {
        logoWidth: logoW,
        logoX: x,
        logoY: y
      }
    }
  } else {
    console.error("Unable to generate logo mockup, no LogoArea tag present");
    validImage = false;
  }
  return (
    <img
      className={classes ? classes : ""}
      loading="lazy"
      src={
        validImage
          ? cloudinaryCore.url(
              shopifyImageResize(imgUrl, `${imgWidth}x${imgHeight}`),
              {
                transformation: [
                  {
                    width: mockupDimensions.logoWidth,
                    gravity: "center",
                    overlay: getPublicIdFromUrl(logoUrl),
                    effect: "make_transparent",
                  },
                  {
                    crop: "crop",
                    flags: "layer_apply",
                    gravity: "north_west",
                    x: mockupDimensions.logoX,
                    y: mockupDimensions.logoY,
                    format: "png",
                  },
                ],
                type: "fetch",
              }
            )
          : shopifyImageResize(imgUrl, `${imgWidth}x${imgHeight}`)
      }
    />
  );
};
